import './index.scss'
import NFTHeader from "@/components/NFTHeader";
import React, {useEffect, useRef, useState} from "react";
import ListView from "@/components/AntListView";
import {hideLoading, showLoading} from "@/components/loading";
import {Toast} from "antd-mobile";
import Service from "@/view/supperzzle/service";
import qs from "query-string";
const BuyPowerRecord = () => {
  const [dataSource, setDataSource] = useState([]);
  const [hasMore, setHasMore] = useState(false);
  const currentPage = useRef(1);
  const pageSize = useRef(2);
  const { fromGems } = qs.parse(window.location.search);

  const loadData = async (isRefesh=false) => {
    const param = {
      pageSize: pageSize.current,
      currentPage: currentPage.current,
      activityType: fromGems ? 2 : 1, // 1:对对碰 2:GuLand对对碰
    }
    try {
      isRefesh && showLoading();
      const res = await Service.getBuyPowerList(param);
      isRefesh && hideLoading();
      if (res.code !== '000000') throw res.msg;
      const newList = res.data.list || [];
      if(currentPage.current === 1) {
        setDataSource(newList);
        setHasMore(res.data.total > newList.length);
      } else {
        setDataSource([...dataSource, ...newList]);
        setHasMore(res.data.total >[...dataSource, ...newList].length)
      }
    } catch (error) {
      isRefesh && hideLoading();
      Toast.show(error);
    }
  }
  const loadMore = async () => {
    currentPage.current += 1;
    await loadData()
  }
  useEffect(()=>{
    loadData(true)
  },[])

  const renderItem = (item) => {
    return (
      <div className="buyPowerContainer">
        <div className="buyPowerTopBox">
          <div className="imgBox">
            <img src={item?.imgUrl || require('@/assets/img/supperzzle/powerIcon2.png')} alt=""/>
          </div>
          <div className="powerTitle">水果</div>
        </div>
        <div className="buyPowerInfoBox">
          <div>{fromGems ? '兑换' : '购买'}时间：{item?.orderTime}</div>
          <div>获得水果：{item.stamina}</div>
          <div>{fromGems ? '实付宝石' : '实际付款'}： {fromGems ? item.gemstonesNum : `¥${item.useCash}`}</div>
        </div>
      </div>
    )
  }
  return (
    <div className="buyPowerRecordPage">
      <NFTHeader midText="购买记录" bgColor={'#FFFFFF'}/>
      <div>
        <ListView
          dataSource={dataSource}
          renderItem={renderItem}
          hasMore={hasMore}
          onRefresh={()=>{
            currentPage.current = 1;
            loadData()
          }}
          onEndReached={loadMore}
          style={{paddingTop: 120}}
          isLoad={true}
        />
      </div>
    </div>
  )
}
export default BuyPowerRecord